import { ColumnType } from '@import/interfaces';
import { InputType } from '@import/enums/input-type.enum';

export const PersonalEmergencyContactColumnsTypes: ColumnType[] = [
    {
        label: 'Primary Emerg. Contact Name',
        relatedLabels: ['EC Primary Name'],
        translatableLabel: 'import.columnTypes.primaryEmergContactName',
        serializeName: 'ecPrimaryName',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Primary Emerg. Contact Relation',
        relatedLabels: ['EC Primary Relation'],
        translatableLabel: 'import.columnTypes.primaryEmergContactRelation',
        serializeName: 'ecPrimaryRelation',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Primary Emerg. Contact Phone',
        relatedLabels: ['EC Primary Phone'],
        translatableLabel: 'import.columnTypes.primaryEmergContactPhone',
        serializeName: 'ecPrimaryPhone',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Secondary Emerg. Contact Name',
        relatedLabels: ['EC Secondary Name'],
        translatableLabel: 'import.columnTypes.secondaryEmergContactName',
        serializeName: 'ecSecondaryName',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Secondary Emerg. Contact Relation',
        relatedLabels: ['EC Secondary Relation'],
        translatableLabel: 'import.columnTypes.secondaryEmergContactRelation',
        serializeName: 'ecSecondaryRelation',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Secondary Emerg. Contact Phone',
        relatedLabels: ['EC Secondary Phone'],
        translatableLabel: 'import.columnTypes.secondaryEmergContactPhone',
        serializeName: 'ecSecondaryPhone',
        input: InputType.string,
        required: false,
    },
];
